// Webpack Imports
import 'bootstrap';


( function ( $ ) {
	'use strict';

	// Focus Search if Searchform is empty
	$( '.search-form' ).on( 'submit', function ( e ) {
		var search = $( '#s' );
		if ( search.val().length < 1 ) {
			e.preventDefault();
			search.focus();
		}
	} );

	$(function(){
		var src = $('.bg-top').data('src')
		console.log(src)
		if ($(window).width() < 576) {
			src += '@xs.jpg'
		}
		else if ($(window).width() > 1280) {
			src += '@2x.jpg'
		} else if (window.devicePixelRatio > 1.0) {
			src += '@2x.jpg'
		} else {
			src += '.jpg'
		}
		$('.bg-top').css('background-image', 'url('+ src +')')
	})

	// $(window).on('scroll', function(){
	// 	var scrollTop = $(window).scrollTop
	// 	$('.lazyload').each(function(i, e){
	// 		if (!$(e).hasClass('lazyloaded')) {
	// 			if ($(e).) {

	// 			}
	// 		}
	// 	})
	// })

	$(window).on('load scroll', function(){
		var scroll = $(this).scrollTop();
		var windowH = $(this).height();
		$('.lazyload').each(function(i, e){
			if (!$(e).hasClass('lazyloaded')) {
				var imgPos = $(e).offset().top;
				if (scroll > imgPos - windowH){
					var src = $(e).data('src')
					// console.log(src)
					if ($(window).width() < 576) {
						src += '@xs.jpg'
					}
					else if ($(window).width() > 1280) {
						src += '@2x.jpg'
					} else if (window.devicePixelRatio > 1.0) {
						src += '@2x.jpg'
					} else {
						src += '.jpg'
					}
					$(e).css('background-image', 'url('+ src +')')
					$(e).addClass('lazyloaded')
				}
			}
		})
		// $('.scrolleffect').each(function(i, e){
		// 	if (!$(this).hasClass('showing')) {
		// 		var imgPos = $(this).offset().top;
		// 		// var imgHeight = $(this).height();
		// 		if (scroll > imgPos - windowH){
		// 			$(this).addClass('showing')
		// 		}
		// 	}
		// });
	})

}( jQuery ) );
